import { setUserIdFun, setToken, setUsername, setAccountFun } from '@/store/locale';
export const loginRelatedInfo = () => {
	setUserIdFun('');
	setToken('');
	setUsername('');
	setAccountFun('');
};
